import { render, staticRenderFns } from "./MedicalCertTemplate.vue?vue&type=template&id=c44b9e2e&scoped=true"
import script from "./MedicalCertTemplate.vue?vue&type=script&lang=js"
export * from "./MedicalCertTemplate.vue?vue&type=script&lang=js"
import style0 from "./MedicalCertTemplate.vue?vue&type=style&index=0&id=c44b9e2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44b9e2e",
  null
  
)

export default component.exports